import React from "react";
import SuccessIcon from "../components/Commands/SuccessIcon/SuccessIcon";
import WarningIcon from "../components/Commands/WarningIcon/WarningIcon";
import ErrorIcon from "../components/Commands/ErrorIcon/ErrorIcon";

const useLogIcon = () => {

  const getIcon = (type) => {
    switch (type) {
      case "INFO":
        return <SuccessIcon />;
      case "WARNING":
        return <WarningIcon />;
      case "ERROR":
        return <ErrorIcon />;
    }
  };

  return getIcon;
};

export default useLogIcon;
